import styled from '@emotion/styled';
import { Modal } from '@lightspeed/flame/Modal';

export const StyledModal = styled(Modal)`
  max-width: 420px;
  width: 420px;
`;
